const Progress01Icon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }]
];

export { Progress01Icon as default };
//# sourceMappingURL=Progress01Icon.js.map
